//component styles
import '../../../FO/components/logo/logo.css';
import '../../../FO/components/header/header.css';
import '../../../FO/components/mainmenu/mainmenu.css';
import '../../../FO/components/searches/searches.css';
import '../../../SHARED/components/slider/slider.css';
import '../../../SHARED/components/carousel/carousel.css';
import '../../../SHARED/components/carousel/carouselschedule.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../../SHARED/components/card/card.css';
import '../../../FO/components/ads/ads.css';
import '../../../FO/components/boxoffice/boxoffice.css';
import '../../../FO/components/movietheaters/movietheaters.css';
import '../../../FO/components/schedule/schedule.css';
import '../../../SHARED/components/pagination/pagination.css';
import '../../../SHARED/components/maps/maps.css';
import '../../../FO/components/boxoffice/boxofficesmall.css';
import '../../../FO/components/lastcomments/lastcomments.css';
import '../../../FO/components/facebooklikesbox/facebooklikesbox.css';
import '../../../FO/components/movieresults/movieresults.css';
import '../../../SHARED/components/movielistitem/movielistitem.css';
import '../../../SHARED/components/articles/articleitem.css';
import '../../../FO/components/movies/movies.css';
import '../../../SHARED/components/filterbutton/filterbutton.css';
import '../../../FO/components/footer/footer.css';
import '../../../FO/components/lastnews/lastnews.css';
import '../../../FO/components/customnews/customnews.css';
import '../../../SHARED/components/filters/filterssoonincinema.css';
import '../../../SHARED/components/movieresultssoonincinema/movieresultssoonincinema.css';
import '../../../FO/components/news/allnews.css';
import '../../../FO/components/news/editorialnews.css';
import '../../../FO/components/newsdetails/newsdetails.css';
import '../../../SHARED/components/newsauthor/newsauthor.css';
import '../../../SHARED/components/comments/comments.css';
import '../../../SHARED/components/searchbytag/searchbytag.css';
import '../../../SHARED/components/auth/authpage.css';
import '../../../FO/components/profile/profile.css';
import '../../../SHARED/components/ticketcarouselitem/ticketcarouselitem.css';
import '../../../SHARED/components/ratingscarouselitem/ratingscarouselitem.css';
import '../../../SHARED/components/favcinemas/favcinemas.css';
import '../../../SHARED/components/savednews/savednews.css';
import '../../../SHARED/components/carouselsearches/carouselsearches.css';
import '../../../FO/components/moviedetails/moviedetails.css';
import '../../../SHARED/components/cinemaprating/cinemaprating.css';
import '../../../FO/components/serialsrecommendedforyou/serialsrecommendedforyou.css';
import '../../../FO/components/newsrecommendedforyou/newsrecommendedforyou.css';
import '../../../SHARED/components/saveditem/saveditem.css';
import '../../../SHARED/components/modalreservation/modalreservation.css';
import '../../../FO/components/festivaldetails/festivaldetails.css';
import '../../../SHARED/components/spinner/spinner.css'
import '../../../FO/components/homepage/homepage.css';
import '../../../FO/components/editprofile/editprofile.css';
import '../../../SHARED/components/festivallistitem/festivallistitem.css';
import '../../../SHARED/components/carousel/carouselfestival.css';
import '../../../FO/components/festivals/festivals.css';
import '../../../SHARED/components/forgotpassword/forgotpassword.css';
import '../../../SHARED/components/favorite/favorite.css';
import '../../../SHARED/components/modalsharing/modalshare.css';
import '../../../SHARED/components/taglistitem/taglistitem.css';
import '../../../SHARED/components/searchresults/searchresults.css';
import '../../../SHARED/components/hourbutton/hourbutton.css';
import '../../../SHARED/components/halldetailsmobile/halldetailsmobile.css';
import '../../../FO/components/thankyou/thankyou.css';
import '../../../FO/components/terms/terms.css';
import '../../../FO/components/confidentiality/confidentiality.css';
import '../../../FO/components/aboutproject/aboutproject.css';
import '../../../FO/components/contact/contact.css';

//miscellaneous styles
import '../../../FO/resources/css/responsive.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../FO/resources/css/general.css';
import 'react-input-range/lib/css/index.css';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'




// WEBPACK FOOTER //
// ./src/FO/resources/js/styles.js